import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowPathRight"><Path d="M2.75 12.2501V11.7501C2.75 10.0932 4.09315 8.75005 5.75 8.75005H13.75V5.32127C13.75 4.89673 14.2457 4.66536 14.5711 4.93801L21.6277 10.8503C22.3432 11.4498 22.3432 12.5503 21.6277 13.1498L14.5711 19.0621C14.2457 19.3347 13.75 19.1034 13.75 18.6788V15.2501H5.75C4.09315 15.2501 2.75 13.9069 2.75 12.2501Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowPathRight;
